<template lang="pug">
.el-container(id="MediaList-container")
  .el-card.el-card-margin-4.el-card-full-width.el-card-full-height-with-scroll(@click.self='selectNone($event)')
    el-header
      span.header-title-underlined
        span.title {{$t('')}}
        el-input.search-input(
          id="MediaList-searchInput",
          size="mini",
          v-model="searchString",
          clearable
        )
          i.el-icon-search.el-input__icon(slot='suffix')
      NaviButtons.float-right(:side="side", @reloadLeftComponent='reloadLeftComponent', @openActionsMenu='openActionsMenu')
      hr.header
    .pagination-row
      el-pagination.pagination(
        id="MediaList-pagination",
        @size-change='handlePaginationSizeChange',
        @current-change='handlePaginationCurrentChange',
        :current-page.sync='currentPaginationPage',
        :page-sizes='[10, 20, 50, 100, 500, 1000]',
        :page-size='10',
        background,
        layout='prev, pager, next, total, sizes',
        :total='mediaFiltered.length'
      )
      .filter-by-type-button
        el-button.view-mode(
          id="DeviceList-waitingContentApprovalFilter",
          @click='toggleViewModeUnlinked()',
          type="text",
          size='mini',
          :title='$t(`Showing ${viewModeUnlinked ? viewModeUnlinked : "all"} media`)'
        )
          font-awesome-icon.muted(:icon="getIconForLinkedState()", :class='{ warning: viewModeUnlinked }')
        FilterByTypeButton(id="MediaList-filerByTypeButton" :side="side", @setMediaTypeFilterActive='setMediaTypeFilterActive')
        SortButton(id="MediaList-sortButton" :side="side", @setMediaSortActive='setMediaSortActive')
    .media-container(:class="{ 'reloading-folder': loading }")
      MediaRow.medium-row(
        v-for="medium in mediaPaginated",
        :medium='medium',
        :media='mediaFiltered',
        :id="'MediaList-medium' + medium.id",
        :key="medium.id",
        :class="{ selected: mediumIsSelected(medium) }",
        @loadEditMediumInMediaEditor='loadEditMediumInMediaEditor(medium)',
        @openRightClickMenu='openRightClickMenu',
        @closeRightClickMenu='closeRightClickMenu',
        @reloadLocalPlayLists='$emit("reloadLocalPlayLists")',
        @playMedium='playMedium',
      )
    el-dialog(:close-on-click-modal="false", :visible.sync="playMediumVisible", @close='playMediumVisible = false; playedMedium = undefined', width="60%")
      Player(:playedMedium='playedMedium', @close-PlayMedium="closePlayMedium()")
    el-dialog(:close-on-click-modal="false",
      :visible.sync="mediumBasicEditorVisible",
      @close='closeMediumBasicEditor()',
      append-to-body, width="60%"
    )
      MediumBasicEditor(id="MediaList-mediumBasicEditor" v-if='mediumInFocus', :mediumId='mediumInFocus.id', @close='closeMediumBasicEditor()')
    el-dialog(:close-on-click-modal="false",
      :visible.sync="extensionConfigEditorVisible",
      @close='closeExtensionConfigEditor()',
      append-to-body, width="60%"
    )
      ExtensionConfigEditor(id="MediaList-extensionConfigEditor" v-if='mediumInFocus', :mediumId='mediumInFocus.id', @close='closeExtensionConfigEditor()')
  RightClickMediumBrowserMenu(ref='RightClickMediumBrowserMenu', @rightClickAction='rightClickAction')
</template>

<script>
import MediaRow from './MediaRow'
import FilterByTypeButton from './FilterByTypeButton'
import SortButton from './SortButton'
import ExtensionConfigEditor from './ExtensionConfigEditor'

import Player from './../File/Player'

import PlayListEditor from './PlayListEditor'
import NaviButtons from './NaviButtons'
import RightClickMediumBrowserMenu from './RightClickMediumBrowserMenu'
import MediumBasicEditor from './MediumBasicEditor'

import ListItemMixin from './ListItem.mixin'

import AssignMixin from '../Linker/assign2.mixin'
import MediaUtilsMixin from '../Common/mediaUtils.mixin'

export default {
  mixins: [ListItemMixin, AssignMixin, MediaUtilsMixin],
  props: ['side', 'setPageInMediaList'],
  async created () {
    if (['Video', 'Image'].includes(this.$store.state.Medium.media_filter[this.side].mediaTypes.map(t => t.name)[0])) {
      this.$store.dispatch('Medium/setTypeInFilter', [ this.side, 'AllMedia' ])
    }
  },
  components: {
    NaviButtons,
    Player,
    PlayListEditor,
    MediaRow,
    FilterByTypeButton,
    SortButton,
    RightClickMediumBrowserMenu,
    MediumBasicEditor,
    ExtensionConfigEditor
  },
  data () {
    return {
      errors: {
      },
      playedMedium: undefined,
      playMediumVisible: false,
      showPlaylistPopoverVisibleId: 0,
      currentPaginationPage: undefined,
      filterVisible: false,
      loading: false,
      loadingStatus: undefined,
      inFolderFilter: false,
      mediumBasicEditorVisible: false,
      mediumInFocus: undefined,
      extensionConfigEditorVisible: false,
      mediaTypeFilterActive: '',
      sortColumnActive: 'id',
      viewModeUnlinked: ''
    }
  },
  methods: {
    getIconForLinkedState () {
      if (this.viewModeUnlinked === 'linked') {
        return 'link'
      }
      if (this.viewModeUnlinked === 'unlinked') {
        return 'unlink'
      }
      if (this.viewModeUnlinked === '') {
        return 'link'
      }
    },
    toggleViewModeUnlinked () {
      if (this.viewModeUnlinked === '') {
        this.viewModeUnlinked = 'linked'
        return
      }
      if (this.viewModeUnlinked === 'linked') {
        this.viewModeUnlinked = 'unlinked'
        return
      }
      if (this.viewModeUnlinked === 'unlinked') {
        this.viewModeUnlinked = ''
      }
    },
    setMediaTypeFilterActive (type) {
      this.currentPaginationPage = 1
      this.$store.dispatch('Medium/paginationSetPage', [ this.side, 1 ])
      type === 'allMedia' ? this.mediaTypeFilterActive = '' : this.mediaTypeFilterActive = type
    },
    setMediaSortActive (column) {
      this.currentPaginationPage = 1
      this.$store.dispatch('Medium/paginationSetPage', [ this.side, 1 ])
      this.sortColumnActive = column
    },
    playMedium (data) {
      this.playedMedium = data
      this.playMediumVisible = true
    },
    closePlayMedium (data) {
      this.playedMedium = undefined
      this.playMediumVisible = false
    },
    rightClickAction (data) {
      if (data.action === 'editMedium') {
        this.mediumInFocus = data.medium
        this.mediumBasicEditorVisible = true
      } else if (data.action === 'configure') {
        this.mediumInFocus = data.medium
        this.extensionConfigEditorVisible = true
      } else {
        this.$emit('rightClickAction', data)
      }
    },
    closeMediumBasicEditor () {
      this.mediumBasicEditorVisible = false
      this.mediumInFocus = undefined
    },
    closeExtensionConfigEditor () {
      this.extensionConfigEditorVisible = false
      this.mediumInFocus = undefined
    },
    openActionsMenu (data) {
      this.openRightClickMenu(data)
      this.$emit('closeRightPanelContextMenu')
    },
    openRightClickMenu (data) {
      this.$refs.RightClickMediumBrowserMenu.openRightClickMenu(data.medium, data.$event)
      this.$emit('closeRightPanelContextMenu')
    },
    closeRightClickMenu () {
      this.$refs.RightClickMediumBrowserMenu.closeRightClickMenu()
      this.$emit('closeRightPanelContextMenu')
    },
    toggleTagFilterVisibility () {
      this.$store.dispatch('Medium/toggleTagFilterVisible')
    },
    getClassForTagFilter () {
      if (this.$store.state.Medium.media_filter[this.side].mediaTags.length > 0) {
        return 'active-filter-tags'
      }
    },
    reloadLeftComponent () {
      this.$emit('reloadLeftComponent')
    },
    selectAll () {
      for (const medium of this.mediaFiltered) {
        if (medium.type.indexOf('PlayListLibrary') === -1) {
          this.$store.dispatch('Medium/addMediumSelectedLeft', medium)
        }
      }
    },
    selectNone ($event) {
      if ($event.ctrlKey || $event.metaKey) return
      this.$store.dispatch('Medium/clearMediaSelectedLeft')
      this.closeRightClickMenu()
    },
    mediumIsSelected (medium) {
      return this.$store.state.Medium.media_selected_left.findIndex(mediumSelected => mediumSelected.id === medium.id) > -1
    },
    getTypeForLibraryFolder () {
      if (this.inFolderFilter) {
        return 'success'
      }
      return 'default'
    },
    getTypeForAllFolders () {
      if (this.inFolderFilter) {
        return 'default'
      }
      return 'success'
    },
    loadEditMediumInMediaEditor (medium) {
      this.$emit('loadEditMediumInMediaEditor', medium)
      this.$store.dispatch('Medium/clearBreadcrumbs')
      this.$store.dispatch('Medium/addMediumIdToBreadcrumbs', medium.id)
    },
    async loadData (force) {
      this.loading = true
      this.currentPaginationPage = 1
      await this.$store.dispatch('Medium/paginationSetPage', [ this.side, 1 ])
      if (this.$store.state.Medium.media_list.length === 0 || force === true) {
        await this.$store.dispatch('Medium/getMediaList')
        await this.$store.dispatch('Medium/analyzeList')
      }
      this.inFolderFilter = this.selectedLibraryFolder
      this.loading = false
    },
    async reloadData () {
      this.$store.commit('User/SET_CHANGING_NETWORK_STATUS_MEDIA', 'Loading media...')
      await this.loadData(true)
      setTimeout(() => {
        this.$store.commit('User/SET_CHANGING_NETWORK_STATUS_MEDIA', undefined)
      }, 500)
    },
    handlePaginationSizeChange (val) {
      this.$store.dispatch('Medium/paginationSetLimit', [ this.side, val ])
    },
    handlePaginationCurrentChange (val) {
      this.$store.dispatch('Medium/paginationSetPage', [ this.side, val ])
    }
  },
  computed: {
    mediaFiltered () {
      let media
      media = this.$store.state.Medium.media_list.filter(m => !['PlayListDesktop', 'PlayListLibraryRoot', 'PlayListLibraryFolder'].includes(m.type))
      if (this.$store.state.Medium.search_by_string.length > 0) {
        media = media.filter(medium => this.__filterByString(medium))
      }
      let allowedMediaIdsAfterTags
      if (this.__tagFilterActive) {
        allowedMediaIdsAfterTags = this.__combineMediaIdsInTagFilter
        media = media.filter(m => allowedMediaIdsAfterTags.includes(m.id))
      }
      if (this.mediaTypeFilterActive.length) {
        const mediaIdsInTypeFilter = this.$store.state.Medium.media_types.find(mt => mt.name === this.mediaTypeFilterActive).media
        media = media.filter(m => mediaIdsInTypeFilter.includes(m.id))
      }
      if (this.viewModeUnlinked === 'unlinked' && this.$store.state.Medium.media_types.find(mt => mt.name === 'UnassignedMedia')) {
        media = media.filter(medium => this.$store.state.Medium.media_types.find(mt => mt.name === 'UnassignedMedia').media.includes(medium.id))
      }
      if (this.viewModeUnlinked === 'linked' && this.$store.state.Medium.media_types.find(mt => mt.name === 'UnassignedMedia')) {
        media = media.filter(medium => !this.$store.state.Medium.media_types.find(mt => mt.name === 'UnassignedMedia').media.includes(medium.id))
      }
      return this.__sortMedia(media)
    },
    __tagFilterActive () {
      return this.$store.state.Medium.media_filter[this.side].mediaTags.length > 0
    },
    __combineMediaIdsInTagFilter () {
      const mediaFilter = this.$store.state.Medium.media_filter[this.side]
      if (!this.$store.state.Medium.media_list || this.$store.state.Medium.media_list.length < 2) return []
      let mediaTags = mediaFilter.mediaTags
      let allowedMediaIds = []
      if (!mediaFilter.mediaTagsAll) {
        for (let index = 0; index < mediaTags.length; index++) {
          allowedMediaIds = allowedMediaIds.concat(mediaTags[index].media)
        }
        allowedMediaIds = [...new Set(allowedMediaIds)]
      } else if (mediaFilter.mediaTagsAll && mediaTags.length > 0) {
        allowedMediaIds = mediaTags[0].media
        for (let index = 1; index < mediaTags.length; index++) {
          // get ids from curent mediaTag
          let ids = mediaTags[index].media
          // filter allowedMediaIds to only those in ids
          allowedMediaIds = allowedMediaIds.filter(value => ids.indexOf(value) !== -1)
        }
      }
      return allowedMediaIds
    },
    mediaPaginated () {
      const offset = (this.$store.state.Medium.pagination[this.side].page - 1) * this.$store.state.Medium.pagination[this.side].limit
      return this.mediaFiltered.slice(offset, offset + this.$store.state.Medium.pagination[this.side].limit)
    },
    filterActiveTags () {
      return (this.$store.state.Medium.media_filter[this.side].mediaTags.length > 0)
    },
    selectedLibraryFolder: {
      get () {
        return this.$store.state.Medium.selected_library_folder
      },
      set (folderMedium) {
        this.$store.commit('Medium/SET_SELECTED_LIBRARY_FOLDER', folderMedium)
      }
    },
    // FIXME DRY
    searchString: {
      get () {
        return this.$store.state.Medium.search_by_string
      },
      set (value) {
        this.$store.dispatch('Medium/paginationSetPage', [ this.side, 1 ])
        this.$store.commit('Medium/UPDATE_SEARCH_STRING', value)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
  .reloading-folder {
    opacity: 0.2;
  }
  .header-title-underlined {
    border: 0px dotted green;
    .search-input {
      width:200px;
      margin-left: -10px;
    }
    .in-folder-button-group {
      margin: 0px 10px;
    }
    .title {
      margin-right: 10px;
    }
  }
  .pagination-row {
    display: flex;
    background-color: $--page-background;
    position: sticky;
    top: -5px;
    z-index: 1;
    .filter-by-type-button {
      margin-left: auto;
      margin-right: 0px;
    }
  }
  .media-container {
    border-top: $--border-light;
    margin-top: 15px;
    padding-bottom: 50px;
  }
  .grab {
    cursor: grab;
  }

  .type-name {
    font-size: $--font-size-base;
    margin-left: 5px;
  }
  .tag-filter-icon {
    margin-left: 5px;
    &.active-filter-tags {
      color: $--color-warning;
    }
  }
  .view-mode {
    margin-right: 6px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Medium/MediaList.vue